/**
 * Lightweight Supabase Service Role Client for Vercel Serverless API Routes
 * 
 * This module provides a service role client that works reliably in Node.js
 * serverless environments WITHOUT importing the heavy browser-focused supabase.ts.
 * 
 * Uses only process.env (no import.meta.env, no window, no browser APIs).
 */

import { createClient } from '@supabase/supabase-js';

let serviceRoleClient = null;

/**
 * Get or create a Supabase service role client for server-side API routes.
 * Uses process.env exclusively — safe for Vercel serverless functions.
 */
export function getServiceRoleClient() {
 if (!serviceRoleClient) {
 const url = process.env.SUPABASE_URL || process.env.VITE_SUPABASE_URL || process.env.NEXT_PUBLIC_SUPABASE_URL;
 const key = process.env.SUPABASE_SERVICE_ROLE_KEY;

 if (!url) {
 throw new Error('Missing SUPABASE_URL environment variable');
 }
 if (!key) {
 throw new Error('Missing SUPABASE_SERVICE_ROLE_KEY environment variable');
 }

 serviceRoleClient = createClient(url, key, {
 auth: {
 autoRefreshToken: false,
 persistSession: false
 },
 global: {
 headers: {
 'Accept': 'application/json'
 // NOTE: Do NOT set 'Content-Type' here — it gets merged with
 // the storage SDK's per-upload Content-Type, producing invalid
 // dual MIME types like "application/json, image/png"
 }
 }
 });

 console.log('Service role client created (serverless)');
 }
 return serviceRoleClient;
}

